import './Booking.css';
import Navbar from '../Navbar/Navbar';
import '../../assets/css/style.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from "axios";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { faMapMarkerAlt ,faClock  } from '@fortawesome/free-solid-svg-icons';

const BACKEND_URL= process.env.API_BASE_URL || 'https://api.hitkarihospital.com:5005';

const RAZORPAY_KEY_ID = 'rzp_live_BE2ZJ1JuZauFvQ'; // Your Razorpay Test Key ID

const loadRazorpayScript = (src) => {
    return new Promise((resolve) => {
        const script = document.createElement('script');
        script.src = src;
        script.onload = () => { resolve(true); };
        script.onerror = () => { resolve(false); };
        document.body.appendChild(script);
    });
};
const formatTime12Hour = (time24) => {
    if (!time24) return 'N/A';
    const [hours, minutes] = time24.split(':');
    let hour = parseInt(hours, 10);
    const ampm = hour >= 12 ? 'PM' : 'AM';
    hour = hour % 12;
    hour = hour ? hour : 12;
    return `${hour}:${minutes} ${ampm}`;
};
const generateTimeSlots = (availability, selectedDate) => {
    const slots = [];
    const interval = 30; // 30-minute intervals

    // Get current time and the booking cutoff time (2 hours from now)
    const now = new Date();
    const bookingCutoffTime = new Date(now.getTime() + 2 * 60 * 60 * 1000);

    // Filter for only available time ranges
    const availableRanges = availability.filter(slot => slot.isAvailable);

    for (const range of availableRanges) {
        // Create Date objects for start and end times based on the selectedDate
        const [startHour, startMinute] = range.startTime.split(':').map(Number);
        const [endHour, endMinute] = range.endTime.split(':').map(Number);

        let currentTimeSlot = new Date(selectedDate);
        currentTimeSlot.setHours(startHour, startMinute, 0, 0);

        const endTimeSlot = new Date(selectedDate);
        endTimeSlot.setHours(endHour, endMinute, 0, 0);

        // Loop and create slots at the specified interval
        while (currentTimeSlot < endTimeSlot) {
            // Check if the slot is bookable (not in the past and not within the 2-hour buffer)
            const isBookable = currentTimeSlot > bookingCutoffTime;

            slots.push({
                time: currentTimeSlot.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true }),
                isBookable: isBookable
            });

            // Increment to the next slot
            currentTimeSlot.setMinutes(currentTimeSlot.getMinutes() + interval);
        }
    }
    return slots;
};
const Booking = () => {
    const { doctorId } = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    // --- Initial Logs for Debugging location.state ---
    // Logged once when the component function body is first executed.
    console.log("[Booking.js] COMPONENT BODY STARTS. location object:", JSON.stringify(location, null, 2));
    console.log("[Booking.js] COMPONENT BODY STARTS. location.state:", location.state);
    console.log("[Booking.js] COMPONENT BODY STARTS. location.state?.patientId:", location.state?.patientId);

    const initialPatientIdFromLocation = location.state?.patientId;
    const [patientId, setPatientId] = useState(initialPatientIdFromLocation);

    // Log after useState initialization
    useEffect(() => {
        console.log("[Booking.js] MOUNT/STATE_INIT_LOG. initialPatientIdFromLocation used for useState:", initialPatientIdFromLocation);
        console.log("[Booking.js] MOUNT/STATE_INIT_LOG. Current patientId state variable:", patientId);
    }, []); // Empty dependency array, runs once after initial render

    // --- Other State Variables ---
    const [showTimingAlert, setShowTimingAlert] = useState(false);
    const [doctor, setDoctor] = useState(null);
    const [loading, setLoading] = useState(true); 
    const [error, setError] = useState(null);
    const [days, setDays] = useState([]);
    const [times] = useState(["9:00 AM", "10:00 AM", "11:00 AM", "12:00 PM","1:00 PM", "2:00 PM", "3:00 PM", "4:00 PM", "5:00 PM", "6:00 PM", "7:00 PM", "8:00 PM", "9:00 PM"]);
    const [selectedSlot, setSelectedSlot] = useState(null);
    const [message, setMessage] = useState("");
    const [isProcessingPayment, setIsProcessingPayment] = useState(false);
    const [razorpayLoaded, setRazorpayLoaded] = useState(false);
    const [selectedDayIndex, setSelectedDayIndex] = useState(0); // Default to the first day (today)
    const [timeSlots, setTimeSlots] = useState([]);
 // --- All useEffect hooks ---
    useEffect(() => {
        if (!patientId) {
            navigate("/register"); // Redirect if no patient ID is found
        }
    }, [patientId, navigate]);

    useEffect(() => {
        const generateDays = () => {
            const dayNames = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
            const newDays = [];
            for (let i = 0; i < 7; i++) {
                const nextDay = new Date();
                nextDay.setHours(0, 0, 0, 0); // Normalize to the start of the day
                nextDay.setDate(new Date().getDate() + i);
                newDays.push({
                    dateObj: nextDay,
                    displayDate: nextDay.toLocaleDateString("en-GB", { day: 'numeric', month: 'short' }).toUpperCase(),
                    dayName: dayNames[nextDay.getDay()],
                    fullDateString: nextDay.toLocaleDateString("en-GB", { day: 'numeric', month: 'short', year: 'numeric' }).toUpperCase()
                });
            }
            setDays(newDays);
        };
        generateDays();
    }, []);

    useEffect(() => {
        if (!doctorId) {
            setError("Doctor ID is missing from URL.");
            setLoading(false);
            return;
        }
        setLoading(true);
        axios.get(`${BACKEND_URL}/api/doctor/${doctorId}`)
            .then(response => {
                setDoctor(response.data);
            })
            .catch(() => {
                setError("Failed to load doctor details.");
            })
            .finally(() => {
                setLoading(false);
            });
    }, [doctorId]);

   useEffect(() => {
        if (doctor && days.length > 0) {
            const selectedDate = days[selectedDayIndex].dateObj;
            
   
            const dateKey = selectedDate.toISOString().split('T')[0];

      
            const scheduleForDay = doctor.dateOverrides?.[dateKey] ?? doctor.defaultAvailability ?? [];
            
            
            const generatedSlots = generateTimeSlots(scheduleForDay, selectedDate);
            setTimeSlots(generatedSlots);
            setSelectedSlot(null); // Reset selection when date changes
        }
    }, [doctor, selectedDayIndex, days]);

    useEffect(() => {
        loadRazorpayScript('https://checkout.razorpay.com/v1/checkout.js')
            .then(loaded => {
                if(loaded) setRazorpayLoaded(true);
                else setError("Could not load payment gateway.");
            });
    }, []);


    // === 2. EVENT HANDLERS ===
    const handleTimeClick = (slot) => {
        if (!slot.isBookable) return;
        setSelectedSlot(slot);
        setMessage("");
        setShowTimingAlert(true);
    };

    const handleProceedToPayment = async () => {
        // Validation checks
        if (!selectedSlot) { setMessage("Please select a time slot."); return; }
        if (!patientId) { setMessage("Patient ID is missing. Please log in again."); return; }
        if (!doctor?.price) { setMessage("Doctor details or fees are not available."); return; }
        if (!razorpayLoaded) { setMessage('Payment gateway is not ready. Please refresh.'); return; }

        setIsProcessingPayment(true);
        const selectedDayObject = days[selectedDayIndex];

        try {
            const appointmentPayload = {
                doctorId: doctor.doctorId, patientId,
                appointmentDate: selectedDayObject.fullDateString, appointmentTime: selectedSlot.time,
                doctorFee: doctor.price,
            };
            const apptResponse = await axios.post(`${BACKEND_URL}/api/appointments/book`, appointmentPayload);
            const tempAppointmentId = apptResponse.data.appointment._id;

            const orderResponse = await axios.post(`${BACKEND_URL}/api/create-order`, {
                amount: doctor.price, appointmentId: tempAppointmentId
            });
            const rzpOrderDetails = orderResponse.data.order;

            const options = {
                key: RAZORPAY_KEY_ID,
                amount: rzpOrderDetails.amount,
                currency: rzpOrderDetails.currency,
                name: "Hitkari Hospital Services",
                description: `Appointment with Dr. ${doctor.name}`,
                order_id: rzpOrderDetails.id,
                handler: async (response) => {
                    const verifyResponse = await axios.post(`${BACKEND_URL}/api/verify-payment`, response);
                    if (verifyResponse.data.success) {
                        navigate(`/booking-success/${tempAppointmentId}`);
                    } else {
                        setMessage("Payment verification failed. Please contact support.");
                    }
                },
                modal: { ondismiss: () => setMessage("Payment was cancelled.") },
                theme: { color: "#1977cc" },
            };
            const rzpInstance = new window.Razorpay(options);
            rzpInstance.open();
        } catch (err) {
            setMessage(err.response?.data?.message || "An error occurred. Please try again.");
        } finally {
            setIsProcessingPayment(false);
        }
    };

    if (loading) {
        console.log("[Booking.js] RENDER - Loading state active.");
        return <div className="main-wrapper"><Navbar /><p style={{textAlign: 'center', marginTop: '20px'}}>Loading booking details...</p></div>;
    }
    if (error) {
        console.log("[Booking.js] RENDER - Error state active:", error);
        return <div className="main-wrapper"><Navbar /><p style={{ color: 'red', textAlign: 'center', marginTop: '20px' }}>Error: {error}</p></div>;
    }
    if (!doctor && !loading) { // Should be caught by error state if doctor fetch failed
        console.log("[Booking.js] RENDER - Doctor information not available (and not loading/error).");
        return <div className="main-wrapper"><Navbar /><p style={{textAlign: 'center', marginTop: '20px'}}>Doctor information not available for ID: {doctorId}.</p></div>;
    }
    // If patientId is valid and doctor is loaded (or at least loading finished and no error specifically for doctor)
    // console.log("[Booking.js] RENDER - Rendering main booking UI. patientId:", patientId, "Doctor:", doctor?.name);

   const generalAvailableSlots = doctor?.defaultAvailability?.filter(slot => slot.isAvailable) ?? [];
    return (
        <div className="main-wrapper">
            <header className="header"><Navbar /></header>
            <div className="breadcrumb-bar">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-md-12 col-12">
                            <nav aria-label="breadcrumb" className="page-breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item active" aria-current="page">Booking</li>
                                </ol>
                            </nav>
                            <h2 className="breadcrumb-title">Booking for  {doctor?.name || '...'}</h2>
                        </div>
                    </div>
                </div>
            </div>
            <div className="content">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            {doctor ? ( // Only render doctor-specific info if doctor object exists
                            <>
                            <div className="card">
                                <div className="card-body">
                                    <div className="booking-doc-info">
                                        <a href={`/doctor-profile/${doctor.doctorId}`} className="booking-doc-img">
                                            {doctor.image ? (
                                                <img src={`${BACKEND_URL}/doctor/${doctor.image}`} alt={doctor.name} />
                                            ) : ( <img src="/path/to/default-doctor-image.jpg" alt="Doctor" /> /* Consider a real default */)}
                                        </a>
                                        <div className="booking-info">
                                            <h4><a href={`/doctor-profile/${doctor.doctorId}`}>{doctor.name}</a></h4>
                                            <p>Speciality: {doctor.speciality}</p>
                                           <div style={{display:'flex', marginBottom:'8px', alignItems:'center' , flexWrap:'wrap' , gap:'10px', maxWidth:'400px'}}>
                                                    <span className="info-label">
                                                        Doctor Timming :
                                                    </span>
                                                    
                                                
                                                     <div className="timings-container">
                                                        {generalAvailableSlots.length > 0 ? (
                                                            generalAvailableSlots.map((slot, idx) => (
                                                                <span key={idx} className="timming">
                                                                    <FontAwesomeIcon icon={faClock} style={{ marginRight: "5px" }} />
                                                                    {formatTime12Hour(slot.startTime)} - {formatTime12Hour(slot.endTime)}
                                                                </span>
                                                            ))
                                                        ) : (
                                                            <span className="timming-not-set">Not Available</span>
                                                        )}
                                                    </div>
                                                    
                                                    </div>
                                            <p>Consultation Fee: <strong>₹{doctor.price}</strong></p>
                                            <p className="text-muted mb-0">
                                                <FontAwesomeIcon icon={faMapMarkerAlt} /> {doctor.address}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="card booking-schedule schedule-widget">
                                <div className="schedule-header">
                                    <div className="row">
                                        <div className="col-md-12"><div className="day-slot"><ul>
                                           {days.map((day, index) => (
                                                        <li key={index} className={selectedDayIndex === index ? 'active' : ''}>
                                                            <a href="#!" onClick={(e) => { e.preventDefault(); setSelectedDayIndex(index); }}>
                                                                <span>{day.dayName}</span>
                                                                <span className="slot-date">{day.displayDate}</span>
                                                            </a>
                                                        </li>
                                                    ))}
                                        </ul></div></div>
                                    </div>
                                </div>
                                 <div className="schedule-cont">
                                    <div className="row">
                                        <div className="col-md-12"><div className="time-slot">
                                              {timeSlots.length > 0 ? (
                                                    timeSlots.map((slot, index) => (
                                                        <button
                                                            key={index}
                                                            className={`timing ${!slot.isBookable ? "disabled" : ""} ${selectedSlot?.time === slot.time ? "selected" : ""}`}
                                                            onClick={() => handleTimeClick(slot)}
                                                            disabled={!slot.isBookable}
                                                        >
                                                            {slot.time}
                                                        </button>
                                                    ))
                                                ) : (
                                                    <div className="no-slots">
                                                        <p>No available slots for this day.</p>
                                                    </div>
                                                )}
                                        </div></div>
                                    </div>
                                </div>
                            </div>

                            {selectedSlot && (
                                <div className="submit-section proceed-btn text-right">
                                    <button
                                        className="btn btn-primary submit-btn"
                                        onClick={handleProceedToPayment}
                                        disabled={isProcessingPayment || !patientId || !razorpayLoaded || !doctor?.price}
                                    >
                                        {isProcessingPayment ? "Processing..." : `Proceed to Pay ₹${doctor.price}`}
                                    </button>
                                </div>
                            )}
                            </>
                            ) : (
                                !loading && <p>Doctor details could not be loaded.</p> // Fallback if doctor is null after loading
                            )}
                            {message && <p className={`mt-2 ${message.toLowerCase().includes("error") || message.toLowerCase().includes("failed") || message.toLowerCase().includes("invalid") ? 'text-danger' : 'text-success'}`}>{message}</p>}
                        </div>
                    </div>
                </div>
            </div>
             {showTimingAlert && (
                <div className="timing-alert-modal">
                    <div 
                        className="timing-alert-overlay" 
                        onClick={() => setShowTimingAlert(false)} // Close modal on overlay click
                    ></div>
                    <div className="timing-alert-content">
                        <h3>Confirm Your Time Slot</h3>
                        <p>Please double-check the selected date and time for your appointment with the Doctor Timming.</p><p>कृपया डॉक्टर टिमिंग के साथ अपनी नियुक्ति के लिए चयनित तिथि और समय की दोबारा जांच कर लें।</p>
                        <button 
                            className="btn btn-primary" 
                            onClick={() => setShowTimingAlert(false)} // Close modal on button click
                        >
                            Okay, Got It
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Booking;